import {TypographyVariants} from '@logistics-frontend/blocks'

export const colorMap: Record<string, 'minor' | 'main'> = {
  TextMinor: 'minor',
  TextMain: 'main',
}

export const typographyMap: Record<string, TypographyVariants> = {
  body2: 'body2',
  caption1: 'caption1',
}
